var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNubePequeaDerechaNaranjaBirdybuyer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 287,
    height: 161,
    viewBox: "0 0 287 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M349 160.992L74.8719 160.129C57.2261 160.44 42.7561 146.236 42.7561 128.601C42.7561 111.184 56.8836 97.0652 74.3115 97.0652H162.167C176.504 97.0652 188.125 85.4513 188.125 71.1225C188.125 56.7938 176.504 45.1799 162.167 45.1799H22.604C10.1189 45.1799 0 35.0673 0 22.5899C0 10.1126 10.1189 0 22.604 0H349V161V160.992Z",
    fill: "#FFD2B0",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNubePequeaDerechaNaranjaBirdybuyer);
export default __webpack_public_path__ + "static/media/nube-pequeña-derecha-naranja-birdybuyer.4f9bbb5d0ff1747f2701e8c2820e0d3b.svg";
export { ForwardRef as ReactComponent };